import { render, staticRenderFns } from "./LunchDayMeals.vue?vue&type=template&id=01046ef8&scoped=true&"
import script from "./LunchDayMeals.vue?vue&type=script&lang=js&"
export * from "./LunchDayMeals.vue?vue&type=script&lang=js&"
import style0 from "./LunchDayMeals.vue?vue&type=style&index=0&id=01046ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01046ef8",
  null
  
)

export default component.exports